import { IController } from 'angular';
import * as _ from 'lodash';

import { ImSchool } from 'Src/ng2/shared/services/im-models/im-school';
import { GraduationPlanTransfer } from '../../../../../../../ng2/shared/constants/graduation-plan-transfer.constant';
import { WizardUtils } from './../../../../../../shared/services/wizard-utils/wizard-utils.service';

export class FourTermsAssignmentCtrl implements IController {
  static inject: string[] = ['$scope', 'ImSchool', 'WizardUtils'];

  private school;
  private studentFilter;
  private cohort;
  private nextGradDate;
  public explainer;
  public filteredStudents;
  public idCollection;
  public totalOnTrack;
  public filterOptions;
  public regentsTextOptions;
  public localTextOptions;
  public additionalRegentsAssignAction;
  public additionalLocalAssignAction;

  constructor(public $scope, private ImSchool: ImSchool, private WizardUtils: WizardUtils) {}

  $onInit(): void {
    this.WizardUtils.startListeningAndLoad(this);
  }

  setUi() {
    this.filterOptions = { columnKeys: ['gradPlan', 'plannedDiplomaType', 'plannedGraduationDate'] };
    this.cohort = this.WizardUtils.getCurrentCohortFilter();
    this.studentFilter = this.cohort ? { status: ['A', 'A-NDG'], cohort: this.cohort } : { status: ['A', 'A-NDG'] };
    this.filteredStudents = this.WizardUtils.getFilteredFlattenedStudents(this.studentFilter);
    this.school = this.WizardUtils.getCurrentSdcSchool();
    this.nextGradDate = this.ImSchool.getNextFourGradDatesForTransfer()[3]; // changes each step
    this.idCollection = this.getStudentsWithCalculatedGradPlan();
    this.totalOnTrack = this.idCollection.regents.studentIds.concat(this.idCollection.local.studentIds);

    this.explainer = this.ImSchool.getDistanceToGradMetricsExplainer(this.school, this.nextGradDate.humanName);

    this.regentsTextOptions = { diplomaType: 'Regents', gradDate: this.nextGradDate.humanName };
    this.localTextOptions = { diplomaType: 'Local', gradDate: this.nextGradDate.humanName };

    this.additionalRegentsAssignAction = this.generateAdditionalWizardFilterAction(
      `Assign Regents ${this.nextGradDate.humanName}`,
      this.regentsTextOptions,
    );

    this.additionalLocalAssignAction = this.generateAdditionalWizardFilterAction(
      `Assign Local ${this.nextGradDate.humanName}`,
      this.localTextOptions,
    );
  }

  private getStudentsWithCalculatedGradPlan() {
    const baseObject = { regents: { _ids: [], studentIds: [] }, local: { _ids: [], studentIds: [] } };
    return _.reduce(
      this.filteredStudents,
      (result: any, student: any) => {
        const { _id, studentId, calculatedGradPlan } = student;
        const gradPlan = _.find(GraduationPlanTransfer, { humanName: calculatedGradPlan });
        if (gradPlan) {
          // guard against calculatedGradPlan === ''
          if (gradPlan.date === this.nextGradDate.humanName) {
            if (gradPlan.diploma === 'Regents') {
              result.regents._ids.push(_id);
              result.regents.studentIds.push(studentId);
            }
            if (gradPlan.diploma === 'Local') {
              result.local._ids.push(_id);
              result.local.studentIds.push(studentId);
            }
          }
        }
        return result;
      },
      baseObject,
    );
  }

  private generateAdditionalWizardFilterAction(label, textOptions) {
    return {
      fourTermAssignment: {
        open: (studentIds, options): void => {
          const _ids = this.WizardUtils.getIdsFromDistrictIds(studentIds);
          const patches = this.WizardUtils.getGradPlanningBulkPatch(
            _ids,
            this.nextGradDate.humanName,
            textOptions.diplomaType,
          );
          this.WizardUtils.confirmThenPatchStudentGradPlans(_ids.length, patches, textOptions);
        },
        label,
      },
    };
  }
}
